export default {
  objectToLoad: {
    front: {
      path: `/shapes/svg/single_calendar_2020.svg`,
      left: 300,
      top: 500,
      scaleX: 0.34,
      scaleY: 0.34
    }
  },
  loadedObjectSettings: {
    title: `Цвета календарной сетки`,
    colorPickers: [
      {
        label: `Будни`,
        pathNumber: 1
      },
      {
        label: `Выходные`,
        pathNumber: 0
      }
    ]
  }
};
